import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import { Typography, TextVariant } from '@components/shared/design/Typography';
import { getAllPadTypes, getPadTypeShortDescriptionByType, getPadTypeTextByType } from '@utils/pads';

const PadSizeDescriptions: React.FC = () => {
  const { t } = useTranslation();
  const padSizes = getAllPadTypes();

  return (
    <CompareTextInfo>
      {padSizes.map((padSize) => {
        const headingShort = t(getPadTypeTextByType(padSize));
        const shortDescription = t(getPadTypeShortDescriptionByType(padSize));

        return (
          <TextInfo key={padSize}>
            <Typography $variant={TextVariant.BodyBoldLG} $mobileVariant={TextVariant.BodyBoldMD}>
              {headingShort}
            </Typography>
            <Typography $variant={TextVariant.BodyRegularLG} $mobileVariant={TextVariant.BodyRegularMD}>
              {' — '}
              {shortDescription}
            </Typography>
          </TextInfo>
        );
      })}
    </CompareTextInfo>
  );
};

export default PadSizeDescriptions;

const CompareTextInfo = styled.div`
  padding-top: 24px;
  padding-right: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const TextInfo = styled.div`
  text-align: left;

  > p {
    line-height: 120%;
    display: inline;
  }
`;
